import React from 'react';
import { Box } from '@mui/joy';
import { useThemeContext } from '../../context/ThemeContext';
import HeaderTwo from '../../component/header/HeaderTwo';
import Footer from '../../component/footer/Footer';
import Breadcrumb from '../../component/common/Breadcrumb';
import ExploreJobCard from '../../element/card/fundi/ExploreJobCard';
import PastJobsCard from '../../element/card/fundi/PastJobsCard';
import FundiActiveJobs from '../../element/card/fundi/FundiActiveJobs';
import FundiHemoSection from '../../element/section/FundiHemoSection';
import SliderExploreJob from '../../element/slidercard/SliderExploreJob';
import ActiveJobPaginate from '../../element/pagination/ActiveJobPaginate';




const FundiHome = () => {

  const { isSM, isMd, isMD, isLg } = useThemeContext()
  return (
    <>
      <Box
        sx={{
          width: isSM ? '100%' : isMd ? '100%' : isLg ? '100%' : '100%',
          height: '100%',
          padding: '0',
          boxSizing: 'border-box',
        }}
      >
        <HeaderTwo />

        <Breadcrumb parent="Home" title="Job" title1="Explore Job" title2="Job Details" />
      
        <Box
          sx={{
            width: isSM ? '100%' : isMD ? '100%' : isMd ? '1207px' : '1207px',
            height: '100%',
           
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'block',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2
          }}
        >
        <FundiHemoSection/>

        <SliderExploreJob/>
        <ActiveJobPaginate/>
         
          <FundiActiveJobs/>
        </Box>
       
        <Footer />
      </Box>


    </>
  )

}

export default FundiHome;









